module.exports = __webpack_public_path__ + "img/bb_g3_eyes-03.946547ff.svg";